export { default } from './ending-dialog';

